module.exports = __webpack_public_path__ + "img/icon-usage.8cf23c5c.svg";